<!-- =========================================================================================
  File Name: ResolutionEdit.vue
  Description: Resolution Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Resolución no encontrada" :active.sync="id_not_found">
      <span>Datos de resolución con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'resolutions'}" class="text-inherit underline"> todas las resoluciones</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Número de resolución" v-model="data_local.number" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Descripción" v-model="data_local.description" :enabled="editing"/>
              </div>
              <div class="w-full vx-row">
                <div class="vx-col w-1/3">
                  <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Prefijo" v-model="data_local.prefix" :enabled="editing"/>
                </div>
                <div class="vx-col w-1/3">
                  <ejs-numerictextbox floatLabelType="Auto" placeholder="Número inicial" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.initialNumber"/>
                </div>
                <div class="vx-col w-1/3">
                  <ejs-numerictextbox floatLabelType="Auto" placeholder="Número final" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.finalNumber"/>
                </div>
              </div>
              <div class="w-full">
                <div style="width: 250px;">
                  <ejs-datepicker floatLabelType="Auto" placeholder="Fecha de autorización" :enable="editing" v-model="data_local.date"/>
                </div>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :multiline="true" :enabled="editing"/>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import {DatePickerPlugin} from '@syncfusion/ej2-vue-calendars';

  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin);
  Vue.use(DatePickerPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        data: null,
        data_local: {
          id: 0,
          number: '',
          description: '',
          prefix: '',
          initialNumber: 0,
          finalNumber: 0,
          comments: ''
        },
        id_not_found: false,
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'resolutions'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/sale/resolutions/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data.date = self.data.date.slice(0, -1);
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var message = '';
        if (!this.data_local.number || this.data_local.number == '') {
          message = 'Debe especificar un número de resolución';
        } else if (!this.data_local.description || this.data_local.description == '') {
          message = 'Debe especificar una descripción';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar resolución',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de resolución',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/sale/resolutions/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la resolución fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'resolution', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar resolución "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando resolución',
          type: 'point'
        });
        var self = this;
        var data = {
          objectId: this.id,
          userId: this.$store.state.AppActiveUser.userId,
          token: this.$store.state.AppActiveUser.token
        };
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/resolutions/delete', data).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Resolución fue eliminada correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'resolutions'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando resolución',
          type: 'point'
        });
      }
      this.getData(this.id);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
